const ERROR_STRINGS = {
  CAMERA_NOT_SUPPORTED: 'お使いのブラウザはカメラ撮影に対応していません。',
  CAMERA_ACCESS_DENIED:
    'カメラアクセスが拒否されました。設定をご確認ください。',
  LINE: {
    GET_FRIEND_STATUS_FAILED: '友だち追加が確認できませんでした。',
    MISSING_LINE_OAUTH_NONCE: 'LINE oauth nonceが存在しません。',
  },
};

export default ERROR_STRINGS;
